/**
 * This regex should only be used on hostnames or domains and is not
 * robust enough to handle raw urls (eg. urls with ports or paths).
 */
export var CheggTldRegex = /(chegg[^\.]*)(.+)$/;
export var CheggTlds = {
  DEFAULT: '.com',
  MX: '.com.mx'
};
export var CheggHeaderKeys = {
  HOSTNAME: 'x-chegg-hostname',
  PASSPORT: 'chegg-passport'
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/utils/dist/esm/urls/constants.js
// module id = 445
// module chunks = 11